import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaGraduationCap, FaBriefcase, FaCode, 
  FaReact, FaNodeJs, FaPython, FaDatabase,
  FaGuitar, FaCamera, FaPlane, FaBookReader,
  FaUniversity, FaAward, FaMedal, FaSchool
} from 'react-icons/fa';
import { SiTypescript, SiJavascript, SiMongodb, SiPostgresql } from 'react-icons/si';
import './About.css';

 
import TypingTitle from './TypingTitle';


const About = () => {
  const skills = [
    { name: 'React', icon: <FaReact />, level: 90 },
    { name: 'Node.js', icon: <FaNodeJs />, level: 85 },
    { name: 'TypeScript', icon: <SiTypescript />, level: 80 },
    { name: 'JavaScript', icon: <SiJavascript />, level: 95 },
    { name: 'Python', icon: <FaPython />, level: 75 },
    { name: 'MongoDB', icon: <SiMongodb />, level: 85 },
    { name: 'PostgreSQL', icon: <SiPostgresql />, level: 80 },
  ];

  const education = [
    {
      institute: 'Assam Down Town University',
      degree: 'Bachelors Of Computer Application(AIML)',
      period: '2022 - Prsesent',
      cgpa: '9.3/10',
      icon: <FaUniversity />,
      achievements: 'Brain Computer Interface Hacakthon 2nd Position'
    },
    {
      institute: 'Cotton University',
      degree: 'Higher Secondary (PCM)',
      period: '2020 - 2022',
      cgpa: '8/10',
      icon: <FaSchool />,
      // achievements: 'Graduated with Honors'
    },
    {
      institute: 'Nichols Higer Secondary School',
      degree: 'Matriculation',
      period: '2012-2020',
      cgpa: '9.4/10',
      icon: <FaAward />,
      // achievements: 'Top of Class'
    }
    // {
    //   institute: 'Berkeley',
    //   degree: 'Summer Research Program',
    //   period: 'Summer 2015',
    //   cgpa: '3.95/4.0',
    //   icon: <FaMedal />,
    //   achievements: 'Best Research Paper Award'
    // }
  ];

  const experience = [
    {
      year: 'Jan 2025 - Apr 2025',
      title: 'App Developer Intern',
      company: 'Indian Institute Of Technology, Guwahati',
      description: 'An ML powered app for disease detection in plants',
      projects: [
        'Developed a real-time analytics dashboard using React and D3.js',
        'Implemented microservices architecture using Node.js and Docker',
        'Led a team of 5 developers for a major client project',
        'Reduced system response time by 40% through optimization'
      ]
    },
    {
      year: 'Sep 2024 - Dec2024',
      title: 'Full Stack Developer Intern',
      company: 'Sane Infotech',
      description: 'Development of a wesbite end to end for digital branding and scaling',
      projects: [
        'Built an e-commerce platform with React and Node.js',
        'Implemented payment gateway integration with Stripe',
        'Developed CI/CD pipeline using Jenkins',
        'Created automated testing framework'
      ]
    },
    {
      year: 'May 2024 - Present',
      title: 'Student Ambassador',
      company: 'Microsoft Learn',
      description: 'Backend development and system architecture',
      projects: [
        'Designed and implemented RESTful APIs',
        'Developed real-time notification system',
        'Optimized database queries improving performance by 50%',
        'Implemented OAuth2 authentication system'
      ]
    },
    {
      year: 'Oct 2023 - Nov 2023',
      title: 'Machine Learning Developer',
      company: 'Bharat Intern',
      description: 'Building robus models for various fields using base machine learning models.',
      projects: [
        'Created responsive web interfaces using React',
        'Implemented state management using Redux',
        'Developed reusable component library',
        'Improved website accessibility to WCAG standards'
      ]
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1
    }
  };

  return (
    <div className="about-container">
      {/* Header Section */}
      <motion.section 
        className="about-header"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
<div className="profile-container">
  <div className="profile-image">
    <img src="/profile.jpg" alt="Rahul Mishra" />
  </div>
  <TypingTitle />
</div>

      </motion.section>

      {/* Bio Section */}
      <motion.section 
        className="bio-section"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.div variants={itemVariants} className="bio-content">
          <h2><FaCode /> Biography</h2>
          <p>
          <span className="bold-text">I was today years old when I realized that ‘console.log(‘life’)’ doesn’t debug existential crises—</span>so I became a Full Stack Developer and Machine Learning Engineer instead. When I’m not busy convincing my code to compile without tantrums, I’m building scalable web apps and AI solutions (or pretending my coffee is debugging juice).
          </p>
          <p>I specialize in building machine learning models that can predict the future—<span  className="bold-text">unless it’s a weekend, then they’re just as clueless as I am.</span> If debugging was a hobby, I’d have a collection of bugs by now. But hey, at least my models are good at making mistakes faster!
          </p>
        </motion.div>
      </motion.section>

      {/* Education Section */}
      <motion.section 
        className="education-section"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <h2>Education</h2>
        <div className="education-grid">
          {education.map((edu, index) => (
            <motion.div 
              key={index}
              className="education-item"
              variants={itemVariants}
            >
              <div className="education-icon">
                {edu.icon}
              </div>
              <div className="education-content">
                <h3>{edu.institute}</h3>
                <h4>{edu.degree}</h4>
                <div className="education-details">
                  <span className="period">{edu.period}</span>
                  <span className="cgpa">CGPA: {edu.cgpa}</span>
                </div>
                <p className="achievements">{edu.achievements}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* Experience Section */}
      <motion.section 
        className="experience-section"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <h2>Experience</h2>
        <div className="timeline">
          {experience.map((item, index) => (
            <motion.div 
              key={index}
              className="timeline-item"
              variants={itemVariants}
            >
              <div className="timeline-icon">
                <FaBriefcase />
              </div>
              <div className="timeline-content">
                <span className="year">{item.year}</span>
                <h3>{item.title}</h3>
                <h4>{item.company}</h4>
                <p>{item.description}</p>
                <div className="project-list">
                  <h5>Key Projects & Achievements:</h5>
                  <ul>
                    {item.projects.map((project, pIndex) => (
                      <li key={pIndex}>{project}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* Skills Section */}
      <motion.section 
        className="skills-section"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <h2>Skills & Expertise</h2>
        <div className="skills-grid">
          {skills.map((skill, index) => (
            <motion.div 
              key={index}
              className="skill-item"
              variants={itemVariants}
            >
              <div className="skill-icon">{skill.icon}</div>
              <div className="skill-info">
                <h3>{skill.name}</h3>
                <div className="skill-bar-container">
                  <motion.div 
                    className="skill-bar"
                    initial={{ width: 0 }}
                    animate={{ width: `${skill.level}%` }}
                    transition={{ duration: 1, delay: 0.2 }}
                  />
                </div>
              </div>
              <span className="skill-percentage">{skill.level}%</span>
            </motion.div>
          ))}
        </div>
      </motion.section>

      {/* Interests Section */}
      <motion.section 
        className="interests-section"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <h2>Interests & Hobbies</h2>
        <div className="interests-grid">
          <motion.div variants={itemVariants} className="interest-item">
            <FaGuitar />
            <h3>Music</h3>
            <p>Playing guitar in my free time</p>
          </motion.div>
          <motion.div variants={itemVariants} className="interest-item">
            <FaCamera />
            <h3>Photography</h3>
            <p>Capturing beautiful moments</p>
          </motion.div>
          <motion.div variants={itemVariants} className="interest-item">
            <FaPlane />
            <h3>Traveling</h3>
            <p>Exploring new places</p>
          </motion.div>
          <motion.div variants={itemVariants} className="interest-item">
            <FaBookReader />
            <h3>Reading</h3>
            <p>Tech blogs and sci-fi novels</p>
          </motion.div>
        </div>
      </motion.section>
    </div>
  );
};

export default About;
